module.exports = __webpack_public_path__ + "img/iosInstall.31638f12.svg";